import { render } from "./IntroComponentJa.vue?vue&type=template&id=b461d6ca&scoped=true"
import script from "./IntroComponentJa.vue?vue&type=script&lang=js"
export * from "./IntroComponentJa.vue?vue&type=script&lang=js"

import "./IntroComponentJa.vue?vue&type=style&index=0&id=b461d6ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b461d6ca"]])

export default __exports__